import { css } from "@emotion/react";
import styled from "@emotion/styled";
import theme from "@theme";

const DrawerTitlesContainer = styled.div`
  display: flex;
  background: ${theme.gradient.themeGradient};
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 20px;
  height: 50px;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const CloseIcon = styled.p`
  cursor: pointer;
  color: white;
`;

const DrawerTitles = styled.span`
  font-size: 17px;
  color: white;
  font-weight: normal;
`;

const RadioStyles = styled.input`
  appearance: none;
  margin-right: 10px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #000;
  outline: none;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s, border-color 0.2s;

  &:checked {
    border-color: orange;
    background-color: white;
  }

  &:checked::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: orange;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const SC = {
  DrawerTitlesContainer,
  CloseIcon,
  DrawerTitles,
  RadioStyles,
};

export default SC;
